module.exports = __webpack_public_path__ + "static/img/7.e8e211d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/7.jpg
// module id = uH2u
// module chunks = 36